export class ReceivePaymentResponseModel {
    transactionId: string;
    transactionNumber: string;
    amount: number;
    accountBalance: string;
    username: string;
    firstname: string;
    lastname: string; 
}